import { atom } from 'recoil';

export const alarmState = atom({
  key: 'alarmState',
  default: [],
});

export const alarmPopupState = atom({
  key: 'alarmPopupState',
  default: false,
});
